import http from "@/axiosConfig";
import toast from "@/global/ToastConfig";

const accessRoute = {
    DOWNLOAD_REPORT: "/reports/overview-report/centro-mayor-frequency",
    LIST_FREQUENCY: "/reports/overview-report/centro-mayor-frequency-list",
    DOWNLOAD_FINANCE_REPORT: "/reports/overview-report/centro-mayor-finance",
    LIST_FINANCE: "/reports/overview-report/centro-mayor-finance-preview",
    DOWNLOAD_FINANCE_COLLECTION: "/reports/overview-report/centro-mayor-finance-collection",
    LIST_FINANCE_COLLECTION: "/reports/overview-report/centro-mayor-finance-collection-list",
    DOWNLOAD_INVOICE_MALL: "/reports/overview-report/centro-mayor-invoice",
    LIST_INVOICE_MALL: "/reports/overview-report/centro-mayor-invoice-list",
    DOWNLOAD_COLLECTION_MALL: "/reports/overview-report/centro-mayor-collection",
    LIST_COLLECTION_MALL: "/reports/overview-report/centro-mayor-collection-list",
    DOWNLOAD_COPY_INVOICE_MALL: "/reports/overview-report/centro-mayor-invoice-copy",
    DOWNLOAD_PURGE_RECORD_MALL: "/reports/overview-report/centro-mayor-purge-record",
    LIST_PURGE_RECORD_MALL: "/reports/overview-report/centro-mayor-purge-record/list",
    DOWNLOAD_MONTHLY_ACTIVE_MALL: "/reports/overview-report/centro-mayor-monthly-active",
    LIST_MONTHLY_ACTIVE_MALL: "/reports/overview-report/centro-mayor-monthly-active/list",
};
export default {

    download(objParams) {
        return new Promise(resolve => {
            let newData = {code: -1};
            http.get(accessRoute.DOWNLOAD_REPORT, {
                params: objParams
            }).then(({data}) => {
                const code = data.code;
                if (code < 0) {
                    toast.error(data.message);
                    return;
                }
                newData = data;
            }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });
    },
    listFrequency(objParams) {
        return new Promise(resolve => {
            let newData = {};
            http.get(accessRoute.LIST_FREQUENCY, {
                params: objParams
            }).then(({data}) => {
                const code = data.code;
                if (code < 0) {
                    toast.error(data.message);
                    return;
                }
                newData = data;
            }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });
    },
    downloadFinance(objParams) {
        return new Promise(resolve => {
            let newData = {code: -1};
            http.get(accessRoute.DOWNLOAD_FINANCE_REPORT, {
                params: objParams
            }).then(({data}) => {
                const code = data.code;
                if (code < 0) {
                    toast.error(data.message);
                    return;
                }
                newData = data;
            }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });

    },
    listFinance(objParams) {
        return new Promise(resolve => {
            let newData = {};
            http.get(accessRoute.LIST_FINANCE, {
                params: objParams
            }).then(({data}) => {
                const code = data.code;
                if (code < 0) {
                    toast.error(data.message);
                    return;
                }
                newData = data;
            }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });
    },
    downloadFinanceCollection(objParams) {
        return new Promise(resolve => {
            let newData = {code: -1};
            http.get(accessRoute.DOWNLOAD_FINANCE_COLLECTION, {
                params: objParams
            }).then(({data}) => {
                const code = data.code;
                if (code < 0) {
                    toast.error(data.message);
                    return;
                }
                newData = data;
            }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });

    },
    listFinanceCollection(objParams) {
        return new Promise(resolve => {
            let newData = {};
            http.get(accessRoute.LIST_FINANCE_COLLECTION, {
                params: objParams
            }).then(({data}) => {
                const code = data.code;
                if (code < 0) {
                    toast.error(data.message);
                    return;
                }
                newData = data;
            }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });

    },
    downloadInvoiceMall(objParams) {
        return new Promise(resolve => {
            let newData = {code: -1};
            http.get(accessRoute.DOWNLOAD_INVOICE_MALL, {
                params: objParams
            }).then(({data}) => {
                const code = data.code;
                if (code < 0) {
                    toast.error(data.message);
                    return;
                }
                newData = data;
            }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });
    },
    listInvoiceMall(objCriteria) {
        return new Promise(resolve => {
            let newData = {};
            http.get(accessRoute.LIST_INVOICE_MALL, {
                params: objCriteria
            }).then(({data}) => {
                console.log(data);
                const code = data.code;
                if (code < 0) {
                    toast.error(data.message);
                    return;
                }
                if (!data.info.records || data.info.records.length === 0) {
                    toast.info("No se encontraron facturas con los criterios ingresados");
                    return;
                }
                newData = data.info;
            }).catch(() => toast.error("Error al consultar facturación"))
                .finally(() => resolve(newData));
        });
    },
    downloadCollectionMall(objParams) {
        return new Promise(resolve => {
            let newData = {code: -1};
            http.get(accessRoute.DOWNLOAD_COLLECTION_MALL, {
                params: objParams
            }).then(({data}) => {
                const code = data.code;
                if (code < 0) {
                    toast.error(data.message);
                    return;
                }
                newData = data;
            }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });
    },
    listCollectionMall(objParams) {
        return new Promise(resolve => {
            let newData = {};
            http.get(accessRoute.LIST_COLLECTION_MALL, {
                params: objParams
            }).then(({data}) => {
                const code = data.code;
                if (code < 0) {
                    toast.error(data.message);
                    return;
                }
                newData = data;
            }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });
    },
    downloadMallInvoiceCopy(objParams) {
        return new Promise(resolve => {
            let newData = {code: -1};
            http.get(accessRoute.DOWNLOAD_COPY_INVOICE_MALL, {
                params: objParams
            }).then(({data}) => {
                const code = data.code;
                if (code < 0) {
                    toast.error(data.message);
                    return;
                }
                newData = data;
            }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });
    },
    downloadPurgeRecords(objParams) {
        return new Promise(resolve => {
            let newData = {code: -1};
            http.get(accessRoute.DOWNLOAD_PURGE_RECORD_MALL, {
                params: objParams
            }).then(({data}) => {
                const code = data.code;
                if (code < 0) {
                    toast.error(data.message);
                    return;
                }
                newData = data;
            }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });
    },

    listPurgeRecords(objParams) {
        return new Promise(resolve => {
            let newData = {};
            http.get(accessRoute.LIST_PURGE_RECORD_MALL, {
                params: objParams
            }).then(({data}) => {
                const code = data.code;
                if (code < 0) {
                    toast.error(data.message);
                    return;
                }
                newData = data;
            }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });
    },
    downloadMonthlyActive(objParams) {
        return new Promise(resolve => {
            let newData = {code: -1};
            http.get(accessRoute.DOWNLOAD_MONTHLY_ACTIVE_MALL, {
                params: objParams
            }).then(({data}) => {
                const code = data.code;
                if (code < 0) {
                    toast.error(data.message);
                    return;
                }
                newData = data;
            }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });

    },
    listMonthlyActive(objParams) {
        return new Promise(resolve => {
            let newData = {};
            http.get(accessRoute.LIST_MONTHLY_ACTIVE_MALL, {
                params: objParams
            }).then(({data}) => {
                console.log(data);
                const code = data.code;
                if (code < 0) {
                    toast.error(data.message);
                    return;
                }
                if (!data.info.records || data.info.records.length === 0) {
                    toast.info("No se encontraron mensuales con los criterios ingresados");
                    return;
                }
                newData = data.info;
            }).catch(() => toast.error("Error al consultar mensualidades"))
                .finally(() => resolve(newData));
        });
    },
}